var r=function(r){return"".concat(r/16,"rem")};export{r as pixelsToRem};
//# sourceMappingURL=pixelsToRem.js.map
